<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @reload="getData"
    />
  </div>
</template>
<script>
import PageMain from './main'
export default {
  components: { PageMain },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
  },
  data() {
    return { tableData: [], loading: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentBookingCode) return
      this.loading = true
      const res = await this.$api
        .shipmentBookingContainerListApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
  },
}
</script>
